<template>
    <transition name="fade">
        <div class="col-12 mb-5">
            <ul class="steps">
                <li class="step step1" :class="[formIndicator.step > 1 ? 'step-success' : 'step-active' ]">
                    <div class="step-content">
                        <span class="step-circle">1</span>
                        <span class="step-text text-center">Prequalification</span>
                    </div>
                </li>
                <li class="step step2" :class="[{'step-active': formIndicator.step == 2}, {'step-success': formIndicator.step > 2}, {'': formIndicator.step < 2}]">
                    <div class="step-content">
                        <span class="step-circle">2</span>
                        <span class="step-text text-center">Business Details</span>
                    </div>
                </li>
                <li class="step step3" :class="[{'step-active': formIndicator.step == 3}, {'step-success': formIndicator.step > 3}, {'': formIndicator.step < 3}]">
                    <div class="step-content">
                        <span class="step-circle">3</span>
                        <span class="step-text">Application Details</span>
                    </div>
                </li>
                <li class="step step4" :class="[{'step-active': formIndicator.step == 4}, {'step-success': formIndicator.step > 4}, {'': formIndicator.step < 4}]">
                    <div class="step-content">
                        <span class="step-circle">4</span>
                        <span class="step-text">Preview</span>
                    </div>
                </li>
                <li class="step" :class="[{'step-active': formIndicator.step == 5 && formIndicator.progress != 'completed'}, {'step-success': formIndicator.progress == 'completed'}, {'': formIndicator.step < 5}]">
                    <div class="step-content">
                        <span class="step-circle">5</span>
                        <span class="step-text">Finish</span>
                    </div>
                </li>
            </ul>
        </div>
    </transition>
</template>

<script>
    export default {
        props: ['formIndicator', 'currentStep'],
        watch: {
            currentStep: function() {
                this.$nextTick(function() {
                    if (this.currentStep) {

                        let content = document.querySelector(".steps");

                        if (this.currentStep == 3) {
                            content.scrollLeft = 160;
                        } else if (this.currentStep == 4) {
                            content.scrollLeft = 300;
                        } else if (this.currentStep == 5) {

                            content.scrollLeft = 450;
                        } else {
                            content.scrollLeft = 0;
                        }
                    }
                });
            }
        },
    }
</script>
<style scoped>
    .step-content {
        width: 8.5rem !important;
        min-width: 8rem !important;
        max-width: 8.5rem !important;
    }

    .step-text {
        word-break: normal !important;
    }

    .step-circle::before {
        width: calc(8.5rem + 1rem - 1.5rem) !important;
    }
</style>